import { FreightOptions } from '../../../types/freight';

export const getEventLabel = (options: FreightOptions[]): string | undefined => {
  if (options.length < 1) {
    return undefined;
  }

  const hasPrime = options.some(({ id, type }) => id?.match(/prime/gi) || type?.match(/prime/gi));
  return hasPrime ? 'Prime' : 'Conventional';
};

export const getFreightInfo = (pagetype: string, options: FreightOptions[]): string => {
  const info = options.map(({ id, price, eta }) => {
    const prize = `${eta.businessDays}:${eta.hours ? eta.hours : '0'}`;
    return `tp:${pagetype}|pe:${id}|fv:${price}|fp:${prize}`;
  });

  return info.join();
};

const ERROR_MESSAGE: Record<string, string> = {
  INVALID_CEP: 'Preencha um CEP válido.',
  OUT_OF_STOCK: 'Produto sem estoque.',
  CANT_DELIVER: 'Desculpe, essa loja não faz entrega desse produto para este CEP.',
  DEFAULT: 'Cálculo de frete indisponível no momento.',
  STORE_NOT_FOUND: 'Desculpe, este serviço não está disponível para o seu CEP. Que tal tentar outro CEP?',
};

export const getErrorMessage = (code: string) => {
  if (!code) {
    return undefined;
  }

  return ERROR_MESSAGE[code] || ERROR_MESSAGE.DEFAULT;
};
